export default __webpack_public_path__ + "static/media/topo.bbef6490.png";